document.addEventListener("DOMContentLoaded", function () {
    const categories = document.querySelectorAll(".category-item");

    function checkVisibility() {
        categories.forEach((category) => {
            const rect = category.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight * 0.8 && rect.bottom >= 0;

            if (isVisible) {
                if (!category.classList.contains("show")) {
                    category.classList.add("show");
                }
            } else {
                if (category.classList.contains("show")) {
                    category.classList.remove("show");
                    // לאתחול האנימציות מחדש כשחוזר לתצוגה
                    setTimeout(() => {
                        category.classList.add("show");
                    }, 100);
                }
            }
        });
    }

    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);
    checkVisibility();
});
document.addEventListener("DOMContentLoaded", function() {
  let elements = document.querySelectorAll(".multicolumn-card");
  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
      }
    });
  }, { threshold: 0.3 });

  elements.forEach(el => observer.observe(el));
});
document.addEventListener("DOMContentLoaded", function() {
  // יצירת observer למעקב אחרי כל אלמנט עם המחלקה collection__description
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      // אם האלמנט נמצא בתצוגה
      if (entry.isIntersecting) {
        entry.target.classList.add("animate--slide-in-active");
      } else {
        // להסיר את המחלקה כשהאלמנט לא בתצוגה, כך שהאפקט יופעל שוב
        entry.target.classList.remove("animate--slide-in-active");
      }
    });
  }, { threshold: 0.5 }); // 50% מהאלמנט צריך להיכנס לתצוגה כדי להפעיל את האפקט

  // לוקח את כל האלמנטים עם המחלקה collection__description ומוסיף להם את ה-observer
  document.querySelectorAll(".collection__description").forEach(function(el) {
    observer.observe(el);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  function showPopup() {
    let popup = document.getElementById("purchase-popup");

    if (!popup) {
      popup = document.createElement("div");
      popup.id = "purchase-popup";
      document.body.appendChild(popup);
    }

    popup.innerHTML = "המוצר נוסף לעגלה בהצלחה✔";
    popup.classList.add("show");

    setTimeout(() => {
      popup.classList.remove("show");
    }, 3000);
  }

  // מאזין לכפתור "הוסף לעגלה"
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener("submit", function(event) {
      event.preventDefault();
      showPopup();

      // שליחת הנתונים בפועל לעגלה
      fetch(form.action, {
        method: "POST",
        body: new FormData(form),
      }).then(response => {
        if (response.ok) {
          console.log("המוצר נוסף לעגלה בהצלחה!");
        }
      });
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const media = entry.target.querySelector('.image-with-text__media');
        const heading = entry.target.querySelector('.image-with-text__heading');
        const text = entry.target.querySelector('.image-with-text__text');

        if (entry.isIntersecting) {
          if (media) media.classList.add('in-view');
          if (heading) heading.classList.add('in-view');
          if (text) text.classList.add('in-view');
        } else {
          if (media) media.classList.remove('in-view');
          if (heading) heading.classList.remove('in-view');
          if (text) text.classList.remove('in-view');
        }
      });
    }, { threshold: 0.2 }); 
  
  document.querySelectorAll('.image-with-text').forEach((section) => {
      observer.observe(section);
    });
  });
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-line");
        } else {
          entry.target.classList.remove("animate-line");
        }
      });
    });

    document.querySelectorAll('.footer a[href="#"]').forEach((el) => {
      observer.observe(el);
    });
  });
  document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    threshold: 0.4
  };

  const elementsToAnimate = document.querySelectorAll(
    ".slideshow__slide .banner__text, .slideshow__slide .banner__buttons"
  );

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate-scale-in");
      } else {
        entry.target.classList.remove("animate-scale-in");
      }
    });
  }, observerOptions);

  elementsToAnimate.forEach(el => {
    observer.observe(el);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector('.product__description');

  if (description) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // הוצאת המחלקה והכנסה מחדש כדי להפעיל שוב את האנימציה
            description.classList.remove("reveal");
            void description.offsetWidth; // ריסט מהיר
            description.classList.add("reveal");
          } else {
            // מסיר את האנימציה כשהיוזר יוצא מהאזור, כדי לאפשר חזרה חוזרת
            description.classList.remove("reveal");
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(description);
  }
});